export const focusOnFirstButton = (element: Element | null | undefined): void => {
  if (!element) return;
  element.querySelector('button')?.focus();
};
